import React from "react";
import { Container, Paper, Typography, Button, Grid } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";

const Dashboard = ({ setAuthenticated }) => {
  const navigate = useNavigate();
  const handleLogout = () => {
    localStorage.removeItem("authToken");
    localStorage.removeItem("authExpiry");
    localStorage.removeItem("userEmail");
    setAuthenticated(false);
    navigate("/");
  };

  return (
    <Container maxWidth="sm">
      <Paper elevation={4} sx={{ p: 4, my: 4, borderRadius: 2 }}>
        <Typography variant="h4" gutterBottom sx={{ fontWeight: 600, textAlign: "center" }}>
          Welcome to the Employee Portal
        </Typography>
        <Grid container spacing={3} sx={{ mt: 2 }}>
          <Grid item xs={12}>
            <Button fullWidth variant="contained" component={Link} to="/attendance" sx={{ py: 2 }}>
              Attendance
            </Button>
          </Grid>
          <Grid item xs={12}>
            <Button fullWidth variant="contained" component={Link} to="/profile" sx={{ py: 2 }}>
              Profile
            </Button>
          </Grid>
          <Grid item xs={12}>
            <Button fullWidth variant="contained" component={Link} to="/leave" sx={{ py: 2 }}>
              Leave
            </Button>
          </Grid>
          <Grid item xs={12}>
            <Button fullWidth variant="contained" component={Link} to="/task" sx={{ py: 2 }}>
              Task
            </Button>
          </Grid>
          <Grid item xs={12}>
            <Button fullWidth variant="outlined" color="secondary" onClick={handleLogout} sx={{ py: 2 }}>
              Logout
            </Button>
          </Grid>
        </Grid>
      </Paper>
    </Container>
  );
};

export default Dashboard;
